import Colors from 'assets/Colors';
import Lang from 'assets/Lang';
import Styles from 'assets/Styles';
import Funcs from 'common/helpers/Funcs';
import Strings from 'common/helpers/Strings';
import UIConst from 'consts/UIConst';
import React from 'react';
import { Animated, StyleSheet, TouchableOpacity, View } from 'react-native';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import BaseText from '../bases/BaseText';
import SimpleInput from '../bases/SimpleInput';
import SafeView from './SafeView';
import StaticFlatlist from './StaticFlatlist';

export default class BottomMenu extends React.PureComponent {
  static instance = new Map();

  static isShow = () => {
    const scope = this.getScope();
    return scope && scope?.state?.visible;
  };

  static show(data = [], title = '', moreState = { hasSearch: false, searchPlaceholder: '', isCustom: false, detail: '', autoHide: true }) {
    const scope = this.getScope();
    if (!scope) return Funcs.log(`${this.name} instance not exist`);
    moreState.autoHide = moreState.autoHide || moreState.autoHide === undefined;
    let state = { visible: true, data, ...moreState, height: 0, fixedHeight: 0, isCustom: !!moreState?.isCustom, hasSearch: !!moreState?.hasSearch };
    state.title = title;
    scope.allData = data;
    scope.setState(state, scope.moveUp);
  }

  static hide() {
    const scope = this.getScope();
    if (!scope) return Funcs.log(`${this.name} instance not exist`);
    scope.moveDown();
  }

  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      title: props.title,
      height: 0
    };
    this.heightMove = new Animated.Value(0);
    BottomMenu.instance.set(this.constructor, this);
  }

  static getScope() {
    return BottomMenu.instance.get(this);
  }

  moveUp = () => {
    Animated.timing(this.heightMove, { toValue: 1, duration: 250, useNativeDriver: true }).start();
  };

  moveDown = () => {
    Animated.timing(this.heightMove, { toValue: 0, duration: 200, useNativeDriver: true }).start(() => {
      this.setState({ visible: false });
    });
  };

  onPressItem = (item) => async () => {
    if (this.state.autoHide) this.moveDown();
    if (item.onPress) {
      await Funcs.delay(250);
      item.onPress();
    }
  };

  onLongPressItem = (item) => async () => {
    if (this.state.autoHide) this.moveDown();
    if (item.onLongPress) {
      await Funcs.delay(250);
      item.onLongPress();
    } else if (item.onPress) {
      await Funcs.delay(250);
      item.onPress();
    }
  };

  onChangeText = (value) => {
    if (this.contentHeight > 0 && this.state.height <= 0) this.setState({ height: this.contentHeight });
    value = Strings.replaceUnicode(value.toLowerCase());
    let searchData = this.allData?.filter((item) => {
      const title = item.title || item.name;
      let isOk = Strings.replaceUnicode(title?.toString().toLowerCase())?.indexOf(value) >= 0;
      isOk = isOk || (item.detail && Strings.replaceUnicode(item.detail?.toString().toLowerCase())?.indexOf(value) >= 0);
      return isOk;
    });
    this.setState({ data: searchData });
  };

  onLayout = ({ nativeEvent }) => {
    if (!this.state.fixedHeight) {
      this.setState({ fixedHeight: nativeEvent.layout.height });
    }
  };

  renderItem = ({ item, index }) => {
    const isTitleCustom = typeof item.title !== 'string';
    const isDetailCustom = typeof item.detail !== 'string';
    const { isCustom } = this.state;
    if (isCustom) {
      return (
        <View style={{ flex: 1 }}>
          {!isTitleCustom ? <BaseText style={styles.textOption}>{item.title}</BaseText> : item.title}
          {!isDetailCustom ? <BaseText style={styles.textOptionDetail}>{item.detail}</BaseText> : item.detail}
        </View>
      );
    }
    return (
      <TouchableOpacity key={index.toString()} onLongPress={this.onLongPressItem(item)} onPress={this.onPressItem(item)} disabled={!item.onPress}>
        <View style={styles.option}>
          {item.icon}
          <View style={{ flex: 1, marginLeft: UIConst.SCALE * 15 }}>
            {!isTitleCustom ? <BaseText style={styles.textOption}>{item.title}</BaseText> : item.title}
            {!isDetailCustom ? <BaseText style={styles.textOptionDetail}>{item.detail}</BaseText> : item.detail}
          </View>
        </View>
      </TouchableOpacity>
    );
  };

  renderSearchBox = () => {
    const { hasSearch, searchPlaceholder = Lang.search } = this.state;
    if (!hasSearch) return null;
    return (
      <View style={[Styles.flexRow, { alignItems: 'center' }]}>
        <SimpleInput
          showClear
          placeholder={searchPlaceholder}
          style={[styles.input, { paddingLeft: UIConst.SCALE * 30 }]}
          onChangeText={this.onChangeText}
          ref={(ref) => (this.InputSearch = ref)}
        />
        <MaterialIcons name={'search'} size={UIConst.SCALE * 20} color={Colors.text} style={{ position: 'absolute', left: UIConst.SCALE * 20 }} />
      </View>
    );
  };

  render() {
    let { data = [], visible, title, detail, fixedHeight } = this.state;
    const translate = this.heightMove.interpolate({ inputRange: [0, 1], outputRange: [UIConst.HEIGHT, 0] });
    if (!visible) return null;
    return (
      <View style={styles.container} keyboardVerticalOffset={0}>
        <Animated.View style={[styles.animatedContainer, { transform: [{ translateY: translate }] }]}>
          <TouchableOpacity activeOpacity={1} style={[Styles.modal, { backgroundColor: 'transparent' }]} onPress={this.moveDown} />
          <View
            onLayout={this.onLayout}
            style={[
              styles.viewOption,
              { backgroundColor: Colors.background, borderColor: Colors.border, borderTopWidth: UIConst.SCALE * 1 },
              fixedHeight > 0 ? { height: fixedHeight } : { maxHeight: UIConst.HEIGHT / 1.4 },
              { paddingBottom: SafeView.getPaddingBottom() }
            ]}>
            {title ? <BaseText style={styles.textTitle}>{title}</BaseText> : null}
            {detail ? (
              <BaseText style={[styles.textOptionDetail, { paddingHorizontal: UIConst.SCALE * 15, marginTop: UIConst.SCALE * 5, textAlign: 'center' }]}>{detail}</BaseText>
            ) : null}
            <StaticFlatlist data={data} renderItem={this.renderItem} disableRefresh ListHeaderComponent={this.renderSearchBox} showsVerticalScrollIndicator={false} />
            {data.length < 1 && <BaseText style={{ textAlign: 'center', margin: UIConst.SCALE * 10 }}>{Lang.none}</BaseText>}
          </View>
        </Animated.View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    bottom: 0,
    left: 0,
    right: 0,
    top: 0
  },
  viewOption: {
    width: '100%',
    minHeight: UIConst.SCALE * 200,
    maxHeight: UIConst.HEIGHT / 1.8
  },
  option: {
    flexDirection: 'row',
    padding: UIConst.SCALE * 15,
    width: '100%',
    alignItems: 'center'
  },
  textOption: {},
  textOptionDetail: {
    fontSize: UIConst.FIX_FONT_SIZE - 2,
    fontStyle: 'italic'
  },
  textTitle: {
    marginTop: UIConst.SCALE * 15,
    fontSize: UIConst.FIX_FONT_SIZE + 2,
    fontWeight: 'bold',
    textAlign: 'center'
  },
  input: {
    flex: 1,
    borderColor: Colors.border,
    borderWidth: UIConst.SCALE * 0.7,
    minHeight: UIConst.SCALE * 35,
    borderRadius: UIConst.SCALE * 6,
    margin: UIConst.SCALE * 5,
    marginHorizontal: UIConst.SCALE * 10
  },
  animatedContainer: {
    flex: 1,
    justifyContent: 'flex-end'
  }
});
